import React from "react";
import { useTranslation } from "@helpers/translate";
import { formatOrderDate } from "@helpers/formatOrders";
import { ReactComponent as CopyIcon } from "@assets/images/icons/copy-alt.svg";
import { DetailRow } from "../../../components/DetailRow";
import { ScrollText } from "../../../components/ScrollText";
import "./TradeMeta.sass";

const Row = (props) => <DetailRow block="trade-meta" {...props} />;

/**
 * Who placed the trade, when, and its id.
 *
 * @param {object} props
 * @param {string|null} props.user
 * @param {number|null} [props.openedAt] ms, the date row shows when set
 * @param {string|number|null} props.tradeId
 * @param {(user: string) => void} [props.onUserClick] opens the trader profile
 */
export const TradeMeta = ({ user, openedAt, tradeId, onUserClick }) => {
  const { __ } = useTranslation();

  return (
    <div className="trade-meta">
      <Row label={__("futures.trade_details.placed_by")}>
        {onUserClick && user ? (
          <button
            type="button"
            className="trade-meta__user"
            onClick={() => onUserClick(user)}
          >
            {user}
          </button>
        ) : (
          user ?? "—"
        )}
      </Row>
      {openedAt != null && (
        <Row
          label={__("futures.trade_details.date")}
          className="trade-meta__row--muted"
        >
          {formatOrderDate(new Date(openedAt).toISOString(), "long")}
        </Row>
      )}
      <Row label={__("futures.trade_details.trade_id")}>
        <ScrollText>{tradeId ?? "—"}</ScrollText>
        <button
          type="button"
          className="trade-meta__copy"
          onClick={() => navigator.clipboard?.writeText(String(tradeId))}
          disabled={tradeId == null}
          aria-label={__("futures.trade_details.copy_id")}
        >
          <CopyIcon />
        </button>
      </Row>
    </div>
  );
};
